import translation_EN from './en/translation_EN.json'
import translation_IT from './it-IT/translation_IT.json'
import translation_BR from './pt-BR/translation_BR.json'

const resources = {
  en: {
    translation: translation_EN
  },
  'pt-BR': {
    translation: translation_BR
  },
  'it-IT': {
    translation: translation_IT
  }
}
export default resources
